import React from "react";
import { PageHeader } from "../components/shared";

export interface AggregatedTripsMapProps {
  companyId: string;
}

export function AggregatedTripsMap({ companyId }: AggregatedTripsMapProps) {
  return (
    <div>
      <PageHeader
        title="Aggregated Trips Map"
        subtitle={`Company ID: ${companyId}`}
      />
    </div>
  );
}

export default AggregatedTripsMap;
